import React from 'react';
import { Badge } from '../ui/badge';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';

const STATUS_OPTIONS = [
  { value: 'green', label: 'Green', className: 'status-green' },
  { value: 'yellow', label: 'Yellow', className: 'status-yellow' },
  { value: 'red', label: 'Red', className: 'status-red' },
];

const getStatusBadge = (status) => {
  const option = STATUS_OPTIONS.find((o) => o.value === status);
  return option ? option.className : 'status-green';
};

export const ScorecardSection = ({ scorecard, onChange }) => (
  <section>
    <div className="section-header flex items-center gap-2 py-1.5 px-3">
      <span className="text-sm">📊</span>
      <span className="text-sm">Scorecard</span>
    </div>
    <div className="p-3">
      <div className="space-y-1">
        {scorecard.map((item, index) => (
          <div
            key={item.name || index}
            className="flex items-center justify-between py-1 border-b border-slate-100 last:border-0"
            data-testid={`scorecard-item-${index}`}
          >
            <span className="text-xs flex-1 pr-2">{item.name}</span>
            <Select value={item.status} onValueChange={(value) => onChange(index, value)}>
              <SelectTrigger className="w-24 h-7 text-xs" data-testid={`scorecard-select-${index}`}>
                <SelectValue>
                  <Badge className={`${getStatusBadge(item.status)} text-xs px-1.5 py-0`}>
                    {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                  </Badge>
                </SelectValue>
              </SelectTrigger>
              <SelectContent>
                {STATUS_OPTIONS.map((opt) => (
                  <SelectItem key={opt.value} value={opt.value}>
                    <Badge className={`${opt.className} text-xs`}>{opt.label}</Badge>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        ))}
      </div>
    </div>
  </section>
);
